export class GrmMediapipeFactory {
    static grmMediapipeClass;
    
    static async factory(options){
        return new (await this.getClass())(options);
    }
    
    static async getClass(){
        if(!this.grmMediapipeClass){
            // if(!!window.OffscreenCanvas || !!window.MediaStreamTrackProcessor){
            if(!!window.OffscreenCanvas && !!window.MediaStreamTrackProcessor){
                this.grmMediapipeClass = (await import("./implement/grm-mediapipie-default")).default;
            }else if(!!window.WebGL2RenderingContext){
                this.grmMediapipeClass = (await import("./implement/grm-mediapipe-webgl")).default;
            }else{
                this.grmMediapipeClass = (await import("./implement/grm-mediapipe-legacy")).default;
            }            
        }
        return this.grmMediapipeClass;
    }
}
